import Piano from './piano.js';

class PianoHash {
	constructor() {
		this.premiumHashPrefix = '#bi-premium-';
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		const self = this;
		jQuery(window)
			.on('hashchange', function () {
				self.checkHash();
			})
			.trigger('hashchange');
	}

	checkHash() {
		const hash = window.location.hash;
		this.processHash(this.getPremiumType(hash));
	}

	getPremiumType(hash) {
		return hash.slice(12);
	}

	processHash(hashType) {
		const allowedTypes = ['login', 'restore'];

		if (allowedTypes.includes(hashType)) {
			Piano.openModal(hashType);
		}
	}

	removeHash() {
		window.location.hash = '';
	}
}

const instance = new PianoHash();
export default instance;
